import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Image, Col, ControlLabel, FormGroup, Button, ButtonToolbar, Glyphicon, HelpBlock } from 'react-bootstrap';
import { connect } from 'react-redux';
import FileUpload from './FileUpload';

class FormFileUpload extends Component {

	render() {
		const { horizontal, required, label, help, input, meta: { touched, error, warning }, image, initialData, disabled } = this.props;
		const formControl = <FileUpload input={input} image={image} initialData={initialData} disabled={disabled} />
		const validationState = touched && (error && "error") || (warning && "warning") || null;
		const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
		const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
		const labelHint = required && <em className='required_s'>*</em>;

		if (horizontal) {
			return (
				<div>
					<FormGroup validationState={validationState}>
						<Col componentClass={ControlLabel} sm={3}>
							{label}{labelHint}
						</Col>
						<Col sm={9}>
							{formControl}
							{errorBlock}
							{helpBlock}
						</Col>
					</FormGroup>
				</div>
			);
		}

		return (
			<div>
				<FormGroup validationState={validationState}>
					<ControlLabel>{label}{labelHint}</ControlLabel>
					{formControl}
					{errorBlock}
					{helpBlock}
				</FormGroup>
			</div>
		);
	}
}

export default FormFileUpload;
